import {createSvgIcon} from '../create-svg-icon';

export const AssistantPhotoIcon = createSvgIcon(
  <path d="m12.36 6 .08.39.32 1.61H18v6h-3.36l-.08-.39-.32-1.61H7V6h5.36M14 4H5v17h2v-7h5.6l.4 2h7V6h-5.6L14 4z" />
, 'AssistantPhotoOutlined');
